import React from 'react'
import APIS from '../../constant/EndPoint'
import ComboboxInput from '../Reusable/Form/ComboboxInput'
import TextField from '../Reusable/Form/TextInput'
import NumberField from '../Reusable/Form/NumberField'
import MultipleSelectField from '../Reusable/Form/MultipleSelectField'

const BranchForm = ({ errors, register, setValue, getValues, clearErrors, watch, branchData = null }: any) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <TextField
          label={"Branch Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"VAT/PAN"}
          register={register("vat_pan")}
          errors={errors?.vat_pan}
        />

        <NumberField
          value={getValues().primary_contact}
          setValue={setValue}
          clearErrors={clearErrors}
          label={"Primary Phone"}
          register={register("primary_contact")}
          errors={errors?.primary_contact}
        />
        <NumberField
          value={getValues().secondary_contact}
          setValue={setValue}
          clearErrors={clearErrors}
          label={"Secondary Contact"}
          register={register("secondary_contact")}
          errors={errors?.secondary_contact}
        />
        <TextField
          label={"Email"}
          register={register("primary_email")}
          errors={errors?.primary_email}
        />
      </div>
      <div className="w-full my-2 text-left mx-4">
        <p>Address</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <ComboboxInput
          label={"Country"}
          placeholder={"Search Country"}
          url={APIS.LOCATION}
          props={{ level: 0 }}
          queryKey={"country"}
          register={register("country")}
          errors={errors?.parent}
          name={"country"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"State"}
          placeholder={"Search State"}
          url={APIS.LOCATION}
          props={{ level: 1 }}
          queryKey={"state"}
          register={register("state")}
          errors={errors?.parent}
          name={"state"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"District"}
          placeholder={"Search District"}
          url={APIS.LOCATION}
          props={{ level: 2 }}
          queryKey={"district"}
          register={register("district")}
          errors={errors?.parent}
          name={"district"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"City"}
          placeholder={"Search City"}
          url={APIS.LOCATION}
          props={{ level: 3 }}
          queryKey={"city"}
          register={register("city")}
          errors={errors?.parent}
          name={"city"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"Landmark"}
          register={register("landmark")}
          errors={errors?.landmark}
        />
      </div>
      <div className="w-full my-2 text-left mx-4">
        <p>Other Info</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <ComboboxInput
          label={"Branch Manager"}
          placeholder={"Branch Manager"}
          url={APIS.STAFF}
          queryKey={"staff"}
          register={register("branch_manager")}
          errors={errors?.branch_manager}
          name={"branch_manager"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"Warehouse"}
          placeholder={"Warehouse"}
          url={APIS.WAREHOUSE}
          props={{ level: 0 }}
          queryKey={"warehouse"}
          register={register("warehouse")}
          errors={errors?.warehouse}
          name={"warehouse"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <MultipleSelectField
          label={"Covered City"}
          queryKey={"covered-city"}
          register={register("covered_city")}
          watch={watch}
          setValue={setValue}
          url={`${APIS.LOCATION}flat-location/`}
          value={branchData?.covered_city ? branchData?.covered_city?.map((item: any, index: number) => ({ label: item?.name, value: item?.id })) : []}
          props={{
            level: 3
          }}
        />
      </div>
    </>
  )
}

export default BranchForm
